module.exports = __webpack_public_path__ + "img/DateRange.7504505f.svg";